import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { DashboardLayout } from '../components/layout';
import AgentCard from '../features/agents/components/AgentCard';
import PageContainer from '../features/agents/components/PageContainer';
import { claudeDark } from '../features/agents/tokens';

const Title = styled.h1`font: 600 26px ${claudeDark.fontSans}; color: ${claudeDark.textPrimary};`;
const Sub = styled.p`font: 400 15px ${claudeDark.fontDisplay}; color: ${claudeDark.textSecondary}; margin: 6px 0 28px;`;
const Grid = styled.div`
  display: grid; grid-template-columns: repeat(auto-fill, minmax(280px, 1fr)); gap: 18px;
`;

/** `/` for a person with several features and no Platforms role: one card per feature. */
export default function HomePage({ homes }) {
  const navigate = useNavigate();
  return (
    <DashboardLayout>
      <PageContainer>
        <Title>ODIN</Title>
        <Sub>Your features. Open one to begin.</Sub>
        <Grid>
          {homes.map((h) => (
            <AgentCard key={h.key} icon="▸" name={h.label} blurb={h.blurb} tag={h.group}
                       onOpen={() => navigate(h.path)} />
          ))}
        </Grid>
      </PageContainer>
    </DashboardLayout>
  );
}
